<span class="svg-inline-icon {{ class }}"
      role="img"
      [attr.aria-label]="alt || null"
      [attr.aria-hidden]="!alt ? 'true' : null"
      [innerHTML]="svgIcon$ | async">
</span>
